<template>
	<div class="imgText">
		<div class="warp">
			<div class="banner">
				<img src="../static/imgs/preface/banner.png" alt="">
			</div>
			<div class="cont">
				<p>不积跬步，无以至千里；不积小流，无以成江海。文物裒藏更是如此。山西博物院四十余万件藏品，社会捐赠始终是一项重要来源。其中，既有文人学者和收藏家的慷慨解囊，也有普通百姓的无私捐献；既有社会团体和企事业单位的热心襄助，也有海外赤子的真情馈赠。一百年集腋成裘，蔚为大观，体现了中华儿女爱祖国、爱家乡的拳拳之心，是中华民族生生不息的强大精神内核。
				</p>
				<p>习近平总书记指示：“文物承载灿烂文明，传承历史文化，维系民族精神，是老祖宗留给我们的宝贵遗产，是加强社会主义精神文明建设的深厚滋养。保护文物功在当代，利在千秋。”中华民族的优秀文化遗产需要中华儿女共同守望，博物馆事业的发展更需要每位公民的关注和建设。社会捐赠是弘扬中华文明的善举和美德。
				</p>
				<p>值此百年华诞之际，山西博物院从众多珍贵的捐赠文物中精选展示五十幅古代书画作品，谨向所有慷慨捐赠的各界人士致敬，希冀观众在欣赏精美艺术的同时，体味捐赠者丰富的学识、高雅的品位和化私为公的社会情怀。
				</p>
				<p>文物是全社会的共同财富，博物馆是文物最好的归宿，文物的保护和利用是博物馆人的永恒使命。希望与全社会有识之士共同努力，以彰令德，以启来人，集涓滴而成流，汇百川以归海！
				</p>
			</div>
		</div>
		<div class="goback" @click="goback"></div>
	</div>
</template>
<script type="text/javascript">
	export default {
		data(){
			return{
			}
		},
		mounted(){
		},
		methods:{
			goback(){
                if(window.history.length == 1){
                    this.$router.push({path:"/"})
                }else{
                    this.$router.go(-1)
                }
            }
		}
	}
</script>
<style scoped>
	.goback{
		width: 1.63rem;
		height: 1.63rem;
		background:url(../static/imgs/goback.png);
		background-size: 100% 100%;
		position: fixed;
		right: .17rem;
		top:50%;
		margin-top: -.815rem;
	}
	.warp{
		margin: 0 auto;
		padding:.2rem .24rem .88rem;
		background-color: #F1F1F1;
	}
	.banner{
		width: 100%;
		border-top-left-radius:20px;
		border-top-right-radius:20px;
		margin-bottom: 0.2rem;
	}
	.banner img{
		width: 100%;
	}
	.cont{background:url("../static/imgs/index/time.png") no-repeat;background-size: cover;height:13.5rem;padding:.29rem .36rem 0;}
	.cont p{font-size: .28rem;line-height: .5rem;color:#555;margin-bottom: .39rem;letter-spacing: .02rem;text-indent: 2em;}
</style>